export default __webpack_public_path__ + "static/media/recycle.7740d165.png";